function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled, { css } from "styled-components";
import Button from "../../Button";
import defaultTheme from "../../defaultTheme";
var StyledButton = styled.div.withConfig({
  displayName: "ActiveButton__StyledButton",
  componentId: "sc-1j3a7nx-0"
})(["&:hover,&:active,&:focus{background:", ";color:", ";transform:none;cursor:default;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.backgroundButtonSecondary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.colorTextButtonSecondary;
}, function (_ref3) {
  var transparent = _ref3.transparent;
  return transparent && css(["&&&{background-color:transparent;}"]);
});
StyledButton.defaultProps = {
  theme: defaultTheme
};

var ActiveButton = function ActiveButton(_ref4) {
  var children = _ref4.children,
      transparent = _ref4.transparent,
      size = _ref4.size;
  return React.createElement(Button, {
    type: "secondary",
    size: size,
    component: function component(props) {
      return React.createElement(StyledButton, _extends({}, props, {
        type: undefined,
        transparent: transparent
      }));
    }
  }, children);
};

export default ActiveButton;